export default class FancyClientList {
  constructor() {
    this.selector = '.clients';
    this.filter = '.domain-filter';
  }

  // eslint-disable-next-line class-methods-use-this
  bootstrap() {
    this.initfilter();
  }

  initfilter() {
    $(this.filter).on('change', function() {
    const term = $(this).find(':selected').data('filter');
      $('.fancy-client').show();
      if (term !== 'all') {
        $(`.fancy-client:not([data-term*=${term}])`).hide();
      }
    });
  }
}
